module.exports = __webpack_public_path__ + "img/UTCAMP-1.5b05e866.jpg";